import { Component, OnChanges, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { MatSnackBar } from '@angular/material/snack-bar';

import { MerklisteService } from '../services/merkliste.service';
import { HttpService } from '../services/http.service';
import { stringify } from 'querystring';

@Component({
  selector: 'app-list-item',
  templateUrl: './list-item.component.html',
  styleUrls: ['./list-item.component.scss']
})
export class ListItemComponent implements OnInit, OnChanges {

  @Input()
  document: any;



  @Output()
  infoRequest: EventEmitter<string> = new EventEmitter<string>();

  checked: boolean;
  placesStandort_aktuell = [];
  placesVerortung = [];
  placesKirchenkreis = [];
  getNewParentID = '';
  i: number;
  waveColor: string;
  waveColorTrans: string;

  constructor(
    private merklisteService: MerklisteService,
    public snackBar: MatSnackBar,
    public http: HttpService
  ) {
    this.merklisteService.MessageCount$.subscribe((merklisteCount: number) => {
      this.checked = this.merklisteService.hasId(this.document['_source']['ID']);
    });


    // console.log('tesssstttinnngggg = ' + this.document['_source']);

  }


  ngOnInit() {
    this.checked = this.merklisteService.hasId(this.document['_source']['ID']);


    if (this.document['_type'] === 'doctyp4') {
      if (this.document['_source']['4_uw_id']) {
        switch (this.document['_source']['4_uw_id']['content']) {
          case '1. Welle':
            this.waveColor = 'rgba(255, 0, 0) ';
            this.waveColorTrans = 'rgba(255, 0, 0, .2) ';
            break;
          case '2. Welle':
            this.waveColor = 'rgba(139, 0, 139) ';
            this.waveColorTrans = 'rgba(139, 0, 139, .2) ';
            break;
          case '3. Welle':
            this.waveColor = 'rgba(255,185,15) ';
            this.waveColorTrans = 'rgba(255,185,15, .2) ';
            break;
          case '4. Welle':
            this.waveColor = 'rgba(0,205,0) ';
            this.waveColorTrans = 'rgba(0,205,0, .2) ';
            break;
          case '5. Welle':
            this.waveColor = 'rgba(121,205,205) ';
            this.waveColorTrans = 'rgba(121,205,205, .2) ';
            break;
          case '6. Welle':
            this.waveColor = 'rgba(0,0,255) ';
            this.waveColorTrans = 'rgba(0,0,255, .2) ';
            break;
          case '7. Welle':
            this.waveColor = 'rgba(240,230,140) ';
            this.waveColorTrans = 'rgba(240,230,140, .2) ';
            break;
          case '8. Welle':
            this.waveColor = 'rgba(255,105,180) ';
            this.waveColorTrans = 'rgba(255,105,180,.2) ';
            break;
          default:
            this.waveColor = 'rgba(102,102,102) ';
            this.waveColorTrans = 'rgba(102,102,102,.2) ';
        }
      }
    }


  if (this.document['_type'] === 'doctyp5') {
    if (this.document['_source']['5_us_welle']) {
    switch (this.document['_source']['5_us_welle']['content']) {
      case '1. Welle':
        this.waveColor = 'rgba(255, 0, 0) ';
        this.waveColorTrans = 'rgba(255, 0, 0, .2) ';
        break;
      case '2. Welle':
        this.waveColor = 'rgba(139, 0, 139) ';
        this.waveColorTrans = 'rgba(139, 0, 139, .2) ';
        break;
      case '3. Welle':
        this.waveColor = 'rgba(255,185,15) ';
        this.waveColorTrans = 'rgba(255,185,15, .2) ';
        break;
      case '4. Welle':
        this.waveColor = 'rgba(0,205,0) ';
        this.waveColorTrans = 'rgba(0,205,0, .2) ';
        break;
      case '5. Welle':
        this.waveColor = 'rgba(121,205,205) ';
        this.waveColorTrans = 'rgba(121,205,205, .2) ';
        break;
      case '6. Welle':
        this.waveColor = 'rgba(0,0,255) ';
        this.waveColorTrans = 'rgba(0,0,255, .2) ';
        break;
      case '7. Welle':
        this.waveColor = 'rgba(240,230,140) ';
        this.waveColorTrans = 'rgba(240,230,140, .2) ';
        break;
      case '8. Welle':
        this.waveColor = 'rgba(255,105,180) ';
        this.waveColorTrans = 'rgba(255,105,180,.2) ';
        break;
      default:
        this.waveColor = 'rgba(102,102,102) ';
        this.waveColorTrans = 'rgba(102,102,102,.2) ';
     }
    }
}
}



  ngOnChanges(changes: any) {
    // console.log(changes);
  }



  public onMerklistToggle(event: any, document: any) {
    const snackBarMessage: string = (event.checked) ?
      'Zur Merkliste hinzugefügt' : 'Von Merkliste entfernt';
    this.snackBar.open(snackBarMessage, '', {
      duration: 1000
    });
    if (event.checked) {
      this.merklisteService.registerItem(document);
    } else {
      this.merklisteService.unregisterItem(document);
    }
  }



  public onInfoClick() {
    this.infoRequest.emit(this.document['_source']['ID']);
  }


}
